<div
  class="position-relative w-100 break-inside-avoid"
  [ngClass]="{
    'mb-1': !alt,
    'my-1': invalid
  }"
>
  <div class="dynamic-form-card__card">
    <div *ngIf="!readonly" class="d-flex justify-content-end mb-1">
      <div class="hstack gap-_5">
        <button luiCab type="button">
          <mat-icon (click)="edit.emit()" svgIcon="edit"></mat-icon>
        </button>
        <button luiCab type="button">
          <mat-icon (click)="delete.emit()" svgIcon="trash"></mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="distinctBy" class="w-100 bold text-start border-bottom pb-1">
      <ng-container
        *ngIf="
          { key: distinctBy, value: item[distinctBy] }
            | fieldMeta : fields as headerMeta
        "
        >{{ headerMeta.label }} {{ item[distinctBy] }}</ng-container
      >
    </div>

    <table class="dynamic-form-card__table w-100">
      <ng-container
        *ngFor="let pair of item | keyvalue | fieldOrder : fields : name"
      >
        <ng-container *ngIf="pair | fieldMeta : fields as meta">
          <tr *ngIf="meta.heading">
            <td colspan="2" class="pt-2"
              ><span [innerHTML]="meta.heading"></span>:</td
            >
          </tr>
          <tr
            *ngIf="
              ((meta && !withinExpansion) ||
                (withinExpansion && pair.key !== distinctToggleListBy)) &&
              meta.type !== 'hidden' &&
              !meta.hidden
            "
          >
            <ng-container *ngIf="meta.type !== 'calc-table'">
              <td class="dynamic-form-card__cell">{{ meta.label }}:</td>
              <td
                class="dynamic-form-card__cell bold"
                [class.text-end]="!!summary"
              >
                <lockton-apps-dynamic-form-cell
                  [type]="meta.type"
                  [value]="pair.value"
                  [parentValue]="item"
                  [addonLeft]="meta.addonLeft"
                  [addonRight]="meta.addonRight"
                  [decimalFormat]="meta.decimalFormat"
                  [options]="meta.options$ | async"
                  [displayWith]="meta.displayWith"
                  (customEvent)="customEvent.emit($event)"
                ></lockton-apps-dynamic-form-cell>
              </td>
            </ng-container>
            <ng-container *ngIf="meta.type === 'calc-table'">
              <td colspan="2">
                <lockton-apps-dynamic-form-calc-table-cell
                  [cellLabel]="meta.label"
                  [rows]="meta?.calcTableMeta?.rows"
                  [headers]="meta?.calcTableMeta?.headers"
                  [summary]="meta?.calcTableMeta?.summary"
                  [decimalFormat]="meta.decimalFormat"
                  [cellValue]="pair.value"
                >
                </lockton-apps-dynamic-form-calc-table-cell>
              </td>
            </ng-container>
          </tr>
        </ng-container>
      </ng-container>
    </table>

    <div
      *ngIf="summary"
      class="d-flex justify-content-between w-100 border-top pt-2 mt-2 bold"
    >
      <div>{{ summary.label }}</div>
      <div>
        {{ summary.addonLeft
        }}{{
          item | total : summary.omit | number : summary.decimalFormat || '1.2'
        }}{{ summary.addonRight }}
      </div>
    </div>
  </div>

  <mat-error *ngIf="invalid && !withinExpansion" i18n
    >*Incomplete entry</mat-error
  >
</div>
